<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper" style="margin-bottom: 16px;">
        <a-form layout="inline" style="display: flex; justify-content: space-between; flex-wrap: wrap;">
          <!-- 左侧：日期范围选择 -->
          <div style="display: flex; align-items: center;">
            <a-form-item label="日期范围" prop="dateRange" style="margin-bottom: 0;">
              <a-range-picker
                  v-model="dateRange"
                  format="YYYY-MM-DD"
                  :allowClear="false"
                  style="width: 260px"
              />
            </a-form-item>
          </div>

          <!-- 右侧：查询 + 重置按钮 -->
          <div style="display: flex; align-items: center; gap: 8px;">
            <a-button type="primary" @click="handleQuery">
              <a-icon type="search" /> 查询
            </a-button>
            <a-button @click="resetQuery">
              <a-icon type="redo" /> 重置
            </a-button>
          </div>
        </a-form>
      </div>

      <!-- 数据展示 -->
      <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
      >

        <span slot-scope="text, record" slot="operation">
          <a-divider type="vertical" />
          <a @click="openDetailDrawer(record.comboId)" >
            <a-icon type="wallet" />详细
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
          :rowKey="(record, index) => index + 1"
      />
      <detail-drawer
          :combo-id="currentComboId"
          :date-range="dateRange"
          :open.sync="drawerVisible"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { convertCodeTotal } from '@/api/statistics/convert-code'
import DetailDrawer from './modules/DetailDrawer.vue'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Convert-code',
  components: {
    DetailDrawer
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: true,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [moment().startOf('day'), moment().endOf('day')],
      currentComboId: null,
      drawerVisible: false,
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => index + 1,
          width: '120',
          align: 'center'
        },
        {
          title: '日期',
          dataIndex: 'dateStr',
          width: '120',
          align: 'center'
        },

        {
          title: '批次名称',
          dataIndex: 'batchName',
          width: '120',
          align: 'center'
        },
        {
          title: '总生成兑换码数量',
          dataIndex: 'totalCount',
          width: '60',
          align: 'center'
        },
        {
          title: '已使用兑换码数量',
          dataIndex: 'usedCount',
          width: '60',
          align: 'center'
        },
        {
          title: '未使用兑换码数量',
          dataIndex: 'unusedCount',
          width: '60',
          align: 'center'
        },
        {
          title: '已过期兑换码数量',
          dataIndex: 'overdueCount',
          width: '60',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '60',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 200,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
      if (this.dateRange && this.dateRange.length === 2) {
        this.queryParam.startDate = this.dateRange[0].format('YYYY-MM-DD')
        this.queryParam.endDate = this.dateRange[1].format('YYYY-MM-DD')
      } else {
        this.queryParam.startDate = undefined
        this.queryParam.endDate = undefined
      }
      convertCodeTotal(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        pageNum: 1,
        pageSize: 10
      }
      this.dateRange = [moment().startOf('day'), moment().endOf('day')]
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    openDetailDrawer (comboId) {
      this.currentComboId = comboId
      this.drawerVisible = true
    }
  }
}
</script>
